export default "__VITE_ASSET__BJAKC99H__"